import React from "react";

/**
 * ════════════════════════════════════════════════════════════════════════════════
 *  [API] 가입경로 상태박스
 * ════════════════════════════════════════════════════════════════════════════════
 *  쇼핑몰(상점사)의 비토리지 API 버튼을 통해 유입/가입한 회원(memberDTO.apiJoinFl === true)에게만
 *  사서함번호/성함 근처에 조그맣게 노출한다.
 *  - 관리자 화면 전반의 파스텔 상태 UI(활성/비활성, 영업완료/영업대기)와 톤을 맞춘다.
 * ════════════════════════════════════════════════════════════════════════════════
 */
function ApiJoinBadge({apiJoinFl, style}) {
    if (apiJoinFl !== true) return null;

    return (
        <span title="쇼핑몰 API 연동으로 가입한 회원"
              style={{
                  display: "inline-flex", alignItems: "center",
                  padding: "1px 6px", marginLeft: "4px",
                  borderRadius: "6px", verticalAlign: "middle",
                  background: "#EFF3FE", border: "1px solid #CCD9FA",
                  color: "#6B87D6", fontSize: "9.5px", fontWeight: "bold",
                  letterSpacing: "0.3px", lineHeight: 1.6, whiteSpace: "nowrap",
                  ...style,
              }}>
            API
        </span>
    );
}

export default ApiJoinBadge;
